import EditProjectModal from './EditProjectModal.container'

export default EditProjectModal
